import GEO from "./GEO";

function App() {
  return (
    <div className="App">
      <GEO />
    </div>
  );
}

export default App;
